import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import logo from "../logo.svg";
import whiteLogo from "../logo-white.svg";
import resumeIcon from "../images/resume-icon.png";
import linkedinIcon from "../images/linkedin-icon.png";

export function Nav({ color }) {
  return (
    <nav id="nav-container">
      <Link to="/#">
        <img
          src={color === "white" ? whiteLogo : logo}
          width="120"
          alt="Mandy's Logo"
        />
      </Link>
      <div className="nav-button-container">
        <HashLink
          smooth
          to="/#projects"
          className={`nav-button ${color === "white" ? "white" : ""}`}
          scroll={(el) =>
            el.scrollIntoView({ behavior: "smooth", block: "start" })
          }
          /*
          onMouseEnter={(e) => {
            e.preventDefault();
            document.getElementById("project-section")?.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }}*/
        >
          Projects
        </HashLink>
        <Link
          to="/about"
          className={`nav-button ${color === "white" ? "white" : ""}`}
        >
          About
        </Link>
        <a
          href="https://drive.google.com/file/d/16A4p9NcmJ3YoLXqorWlwKvCWe-b6mVJ0/view?usp=sharing"
          target="_blank"
          rel="noopener noreferrer"
          className={`nav-button ${color === "white" ? "white" : ""}`}
        >
          Resume
        </a>
      </div>
    </nav>
  );
}

export function Footer() {
  return (
    <footer className="black">
      <Link to="/">
        <img src={whiteLogo} alt="logo" />
      </Link>
      <div id="quick-links">
        <a
          href="https://docs.google.com/document/d/1NlYOyMxhox6EPObHujZXJMejMzLz0v1_HlrcDcRGQvw/edit?usp=sharing"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={resumeIcon} alt="Resume Icon" />
        </a>
        <a
          href="https://www.linkedin.com/in/tsai-chen-lin"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={linkedinIcon} alt="LinkedIn Icon" />
        </a>
      </div>
    </footer>
  );
}
